import axios from "axios";

// export const BASE_URL = "https://madeinheavenserver-production.up.railway.app/";
// export const BASE_URL = "https://madeinheaven.backend.8jdp13yt.a2hosted.com/";
// export const BASE_URL = "https://apimade.techgigs.in/";

//export const BASE_URL = "http://localhost:8000/";
export const BASE_URL = "https://api.madeinheaven.ca/";
export const PDE = axios.create({ baseURL: BASE_URL });
